export default __webpack_public_path__ + "6a4ebd66918b1e1566bf590b624e159c.png";